import React, { useRef } from 'react';
import { useSelector } from 'react-redux';

import { Button, ButtonTypes } from 'src/presentation/components/agent_desktop_components';
import {
  selectCurrentThread,
  selectIsDirty,
} from 'src/presentation/components/pages/sidekick/threads/actions/threadsUiSlice';
import {
  NavigationPanel,
  SaveButton,
} from 'src/presentation/components/pages/sidekick/threads/components/ControlBar.tsx/ControlBar';
import NewThreadModal, {
  NewThreadModalRef,
} from 'src/presentation/components/pages/sidekick/threads/components/NewThreadModal';

export const ControlBarAnon = ({ className, onBackToModule }: { className: string; onBackToModule?: () => void }) => {
  const newThreadModalRef = useRef<NewThreadModalRef>(null);
  const isDirty = useSelector(selectIsDirty);
  const thread = useSelector(selectCurrentThread);

  const handleBackToThread = () => {
    onBackToModule?.();
  };

  const backButton = (
    <Button type={ButtonTypes.SECONDARY} onClick={handleBackToThread}>
      {`Back to ${thread.name}`}
    </Button>
  );

  return (
    <>
      <NavigationPanel className={className}>
        {backButton}
        <SaveButton newThreadModalRef={newThreadModalRef} thread={thread} disabled={!isDirty} />
        <NewThreadModal ref={newThreadModalRef} />
      </NavigationPanel>
    </>
  );
};
